import { Card, Col, Form, message, Row } from "antd";

import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import axios from "services/axiosB2C";
import { RequestToken } from "../../../../services/b2c";

const FormItem = Form.Item;

class CustomerCarDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerCar: {},
    };
  }

  componentDidMount() {
    this.getCustomerCarDetail(this.props.match.params.id);
  }

  async getCustomerCarDetail(id) {
    try {
      let token = await RequestToken();
      axios
        .get(`/customercars/${id}`, {
          headers: {
            Authorization: token,
          },
        })
        .then(result => {
          this.setState({ customerCar: result.data.customerCar });
        })
        .catch(err => {
          message.error("Gagal request data customer car");
        });
    } catch (e) {
      message.error("Gagal request data customer car");
    }
  }

  render() {
    const { customerCar } = this.state;
    return customerCar.id ? (
      <Card title="Customer Car">
        <div id="CustomerCarDetail">
          <Row>
            <Col xs={24} md={12}>
              <Card title="EMAIL MEMBER">
                <span className="ant-form-text form-text-mod">
                  {customerCar.user ? customerCar.user.email : null}
                </span>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card title="HARI/TGL DIBUAT">
                <span className="ant-form-text form-text-mod">
                  {moment(customerCar.created_at).format(
                    "dddd, D MMMM YYYY HH:mm"
                  )}
                </span>
              </Card>
            </Col>
          </Row>

          <Row>
            <Card title="DATA MOBIL CUSTOMER">
              <Col xs={24} md={12}>
                <FormItem label="Brand">
                  <span className="ant-form-text form-text-mod">
                    {customerCar.brand}
                  </span>
                </FormItem>
                <FormItem label="Model">
                  <span className="ant-form-text form-text-mod">
                    {customerCar.type}
                  </span>
                </FormItem>
                <FormItem label="Tipe">
                  <span className="ant-form-text form-text-mod">
                    {customerCar.spec}
                  </span>
                </FormItem>
                <FormItem label="Tahun">
                  <span className="ant-form-text form-text-mod">
                    {customerCar.year}
                  </span>
                </FormItem>
              </Col>
              <Col xs={24} md={12}>
                <FormItem label="Warna">
                  <span className="ant-form-text form-text-mod">
                    {customerCar.color}
                  </span>
                </FormItem>
                <FormItem label="Nomor Polisi">
                  <span className="ant-form-text form-text-mod">
                    {customerCar.license_plate}
                  </span>
                </FormItem>
                <FormItem label="Nomor Rangka">
                  <span className="ant-form-text form-text-mod">
                    {customerCar.engine_number}
                  </span>
                </FormItem>
                <FormItem label="Tahun STNK">
                  <span className="ant-form-text form-text-mod">
                    {moment(customerCar.stnk_term).format("YYYY-MM-DD")}
                  </span>
                </FormItem>
              </Col>
            </Card>
          </Row>
        </div>
      </Card>
    ) : null;
  }
}

export default CustomerCarDetail;



// WEBPACK FOOTER //
// src/components/Dashboard/B2C/CustomerCar/CustomerCarDetail.js